import React,{useState} from 'react';
import EmployAside from '../aside';
import FacturationIndex from './ma-facturation';

const MaFacturation = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className='main-page-wrapper'>
    
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <FacturationIndex setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default MaFacturation;